import { render } from "./tw-grid-edit.vue?vue&type=template&id=27ccfd80"
import script from "./tw-grid-edit.vue?vue&type=script&lang=js"
export * from "./tw-grid-edit.vue?vue&type=script&lang=js"
script.render = render

export default script